import React from "react";
import { FilterComponent } from "./";
import { buildTableValues } from "../../utils/customization/filter";

// prettier-ignore
const ALL_COEFS = [
  -20.428, 143.85, -369.694, 448.204, -251.125, 35.864, 16.362, -3.253, 0.734, 0.487, 0
];

let tableValues:
  | {
      rgb: string;
    }
  | undefined;

const Darkfan: FilterComponent = ({ id, height, width }) => {
  if (!tableValues) {
    tableValues = {
      rgb: buildTableValues(ALL_COEFS),
    };
  }

  return (
    <filter
      colorInterpolationFilters="sRGB"
      filterUnits="objectBoundingBox"
      height={height}
      id={id}
      width={width}
      x={0}
      y={0}
    >
      <feComponentTransfer in="SourceGraphic">
        <feFuncR tableValues={tableValues.rgb} type="table" />
        <feFuncG tableValues={tableValues.rgb} type="table" />
        <feFuncB tableValues={tableValues.rgb} type="table" />
        <feFuncA type="identity" />
      </feComponentTransfer>
    </filter>
  );
};

export default Darkfan;
